import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface BulkShiftUploadCompletedWithFailuresProps extends BaseTemplateProps {
  csvHistoryLink: string
}

export const BulkShiftUploadCompletedWithFailures: TemplateDefinition<BulkShiftUploadCompletedWithFailuresProps> =
  {
    renderParams: (props: BulkShiftUploadCompletedWithFailuresProps) => ({
      messageKey: 'notificationsDomain.templates.bulkShiftUploadCompletedWithFailuresSubheader',
      values: {
        givenName: props.givenName,
        csvHistoryLink: props.csvHistoryLink,
      },
    }),
    getLink: (props: BulkShiftUploadCompletedWithFailuresProps): string =>
      props?.csvHistoryLink || '',
  }
